export default __webpack_public_path__ + "static/media/shield-light.1b762428.png";